import React from 'react';
import Gallery from '../components/sections/Gallery';
import PageHeader from '../components/ui/PageHeader';
import './StaticPage.css';

const GalleryPage: React.FC = () => (
  <div className="static-page">
    <PageHeader page="gallery" />
    <Gallery />
  </div>
);

export default GalleryPage;
